import {combineReducers} from 'redux';
import {createReducer} from '@reduxjs/toolkit';
import {ThemeOptions} from '@material-ui/core';
import {globalThemeChangedAction} from 'module/Theme/action/ThemeAction';

const global = createReducer<ThemeOptions | null>(null, builder => builder
	.addCase(globalThemeChangedAction, (state, {payload}) => payload),
);
export const ThemeReducerNS = {Theme: combineReducers({global})}
export type ThemeStateType = { Theme: ReturnType<typeof ThemeReducerNS.Theme> }